export default __webpack_public_path__ + "static/media/midleDog.695a7da6.svg";